import { useEffect, useState } from "react";
import { api } from "@/lib/api";

function UrgencyBadge({ score }) {
  const n = Number(score || 0);
  let bg, fg, label;
  if (n >= 70) { bg = "#C4A265"; fg = "#0A2540"; label = "HIGH"; }
  else if (n >= 40) { bg = "rgba(196,162,101,0.20)"; fg = "#0A2540"; label = "MED"; }
  else { bg = "rgba(10,37,64,0.06)"; fg = "rgba(10,37,64,0.55)"; label = "LOW"; }
  return (
    <span data-testid="urgency-badge" className="inline-flex items-center gap-2 px-2 py-0.5 rounded-sm text-[10px] uppercase tracking-widest font-medium"
      style={{ backgroundColor: bg, color: fg }}>
      {n} · {label}
    </span>
  );
}

export default function AgentFlags() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/agent/flags").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);

  return (
    <div data-testid="agent-flags-page">
      <div className="eyebrow mb-2">Urgency Watchlist</div>
      <h1 className="aperture-h1 text-4xl mb-10">Flags.</h1>

      <div className="bg-white rounded-sm border overflow-x-auto" style={{ borderColor: "rgba(10,37,64,0.10)" }}>
        <table className="w-full text-sm">
          <thead className="bg-navy/5"><tr>{["Parcel ID","Urgency Score","Last Flag Update"].map(h=><th key={h} className="px-4 py-3 text-left eyebrow" style={{color:"#0A2540"}}>{h}</th>)}</tr></thead>
          <tbody>
            {rows === null && <tr><td colSpan="3" className="px-4 py-10 text-center text-navy/50">Loading…</td></tr>}
            {rows?.length === 0 && <tr><td colSpan="3" className="px-4 py-10 text-center text-navy/50">No flags yet.</td></tr>}
            {rows?.map((r, i) => (
              <tr key={`${r.parcel_id}-${i}`} className="border-t" data-testid={`flag-row-${r.parcel_id}`} style={{ borderColor: "rgba(10,37,64,0.08)" }}>
                <td className="px-4 py-3 font-mono text-xs">{r.parcel_id}</td>
                <td className="px-4 py-3"><UrgencyBadge score={r.urgency_score} /></td>
                <td className="px-4 py-3 text-navy/60 text-xs">{r.last_flag_update ? new Date(r.last_flag_update).toLocaleString() : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
